module.exports = __webpack_public_path__ + "dc472a1f5c505efc3366c9b398021c06.png";